export const createStopConnection = (connectionsRef: React.MutableRefObject<Map<string, any>>) => {
  return async (chatKey: string) => {
    const conn = connectionsRef.current.get(chatKey);
    if (!conn) return;
    try {
      await conn.stop();
    } catch (err) {
      console.warn('SignalR stop failed', err);
    }
    connectionsRef.current.delete(chatKey);
  };
};

export const createStopAllConnections = (connectionsRef: React.MutableRefObject<Map<string, any>>) => {
  return async (exceptId?: string) => {
    const stops: Promise<any>[] = [];
    connectionsRef.current.forEach((conn, key) => {
      if (exceptId && key === exceptId) return;
      stops.push(conn.stop().catch(() => undefined));
      connectionsRef.current.delete(key);
    });
    if (stops.length > 0) {
      await Promise.all(stops);
    }
  };
};
